import React from "react";
import styled from "@emotion/styled";
import { useSelector } from "react-redux";

import { responsive } from "../../utils/style";
import { css } from "@emotion/react";

import BannerForOtherDT from "../../assets/images/Hdesktop_content.png";
import BannerForOtherTB from "../../assets/images/Htablet_content.png";
import BannerForOtherMB from "../../assets/images/Hmobile_content.png";
import BannerForUserDT from "../../assets/images/Hdesktop.png";
import BannerForUserTB from "../../assets/images/Htablet.png";
import BannerForUserMB from "../../assets/images/Hmobile.png";

const Description = () => {
  const { role = [] } = useSelector((s) => s.auth.userInfo);
  console.log(role);
  const isAdmin = role.includes("admin");
  const isMonk = role.includes("monk");
  const isStudent = role.includes("student");

  const isOther = !(isAdmin || isMonk || isStudent);

  return (
    <Container>
      <Background>
        <Banner isOther={isOther} id="homeBanner">
          <ImageContainer>
            <BannerImageDT src={isOther ? BannerForOtherDT : BannerForUserDT} />
            <BannerImageTB src={isOther ? BannerForOtherTB : BannerForUserTB} />
            <BannerImageMB src={isOther ? BannerForOtherMB : BannerForUserMB} />
          </ImageContainer>
          <BannerDescriptionContainerS>
            <BannerDescription>
              &nbsp;&nbsp;&nbsp;&nbsp;เว็บแอปพลิเคชันนี้ให้สามเณรบันทึกพฤติกรรมการฉัน
              อาหารและออกกำลังกายของตนเองสัปดาห์ละ 1 วัน เป็น ระยะเวลาติดต่อกัน
              4-16 สัปดาห์ โดยมีสื่อให้ความรู้ แรงบันดาลใจและระบุเป้าหมายชัดเจน
              ในการปรับเปลี่ยน พฤติกรรม การกรอกข้อมูลพฤติกรรมการฉันและการ
              ออกกำลังกาย ในแต่ละครั้งจะถูกคำนวณเป็นคะแนน
              ซึ่งจะมีการนำคะแนนสะสมของสามเณรมาจัดเรียงลำดับ Ranking
              เทียบกันในระดับห้องเรียน ชั้นเรียน และ โรงเรียน
              คะแนนสะสมของสามเณรที่สูงถึงเกณฑ์กำหนด ระบบจะมอบเหรียญ
              ดาวและถ้วยรางวัลแบบออนไลน์ เว็บแอปพลิเคชันนี้
              ได้รับการออกแบบให้เป็นการแข่งขัน
              กันภายในภาคการศึกษาส่วนผู้ที่ทำคะแนนได้ไม่ดี มีตัวช่วย
              ในการวิเคราะห์ปัญหา ให้แนวทางแก้ไข และเสริมกำลังใจ
              นอกจากนั้นยังมีจุดให้เช็กภาวะโภชนาการ บันทึกและ ติดตามผล
              เพื่อประโยชน์ของสามเณรในการดูแลภาวะ
              โภชนาการของตนเองและเพื่อการติดตามดูแลภาวะ
              โภชนาการของสามเณรโดยพระอาจารย์หรือครูสุขศึกษา
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;เว็บแอปพลิเคชัน เณรกล้า โภชนาดี พัฒนาโดย
              ศาสตราจารย์ ดร.จงจิตร อังคทะวานิช ภายใต้โครงการ
              “การพัฒนาสื่อและหลักสูตรโภชนาการสามเณรสมวัยและการขับเคลื่อนสุขภาวะพระสงฆ์และสามเณรโดยภาคีร่วม”
              ซึ่งได้รับการสนับสนุนจากสำนักงานกองทุนสนับสนุนการสร้างเสริมสุขภาพ
              (“สสส.”)
              เพื่อช่วยให้สามเณรในระดับชั้นมัธยมศึกษาในโรงเรียนพระปริยัติธรรมทั่วประเทศไทย
              ได้รับการสร้างเสริมภาวะโภชนาการที่ดี
              โดยมีครูซึ่งรับผิดชอบในรายวิชาสุขศึกษา
              ซึ่งอาจเป็นพระสงฆ์ที่เป็นพระอาจารย์หรือครูฆราวาส
              เป็นผู้ดูแลสามเณรในการใช้สื่อเว็บแอปพลิเคชัน “เณรกล้า โภชนาดี”
              และทำแบบทดสอบชุดความรู้ “เณรกล้า โภชนาดี” ออนไลน์
              เพื่อเป็นกิจกรรมเสริมหลักสูตรและการให้ความรู้ทางโภชนาการ
            </BannerDescription>
            {/* <BannerDescriptionContainer>
              <BannerDescription>
                &nbsp;&nbsp;เว็บแอปพลิเคชัน เณรกล้า โภชนาดี พัฒนาโดย ศาสตราจารย์
                ดร.จงจิตร อังคทะวานิช ภายใต้โครงการ{" "}
                <strong>
                  “การพัฒนาสื่อและหลักสูตรโภชนาการสามเณรสมวัยและการขับเคลื่อนสุขภาวะพระสงฆ์และสามเณรโดยภาคีร่วม”
                </strong>{" "}
                ซึ่งได้รับการสนับสนุนจากสำนักงานกองทุนสนับสนุนการสร้างเสริมสุขภาพ
                (“สสส.”)
                เพื่อช่วยให้สามเณรในระดับชั้นมัธยมศึกษาในโรงเรียนพระปริยัติธรรมทั่วประเทศไทย
                ได้รับการสร้างเสริมภาวะโภชนาการที่ดี
                โดยมีครูซึ่งรับผิดชอบในรายวิชาสุขศึกษา
                ซึ่งอาจเป็นพระสงฆ์ที่เป็นพระอาจารย์หรือครูฆราวาส
                เป็นผู้ดูแลสามเณรในการใช้สื่อเว็บแอปพลิเคชัน “เณรกล้า โภชนาดี”
                และทำแบบทดสอบชุดความรู้ “เณรกล้า โภชนาดี” ออนไลน์
                เพื่อเป็นกิจกรรมเสริมหลักสูตรและการให้ความรู้ทางโภชนาการ
              </BannerDescription>
            </BannerDescriptionContainer> */}
          </BannerDescriptionContainerS>
        </Banner>
      </Background>
    </Container>
  );
};
const Container = styled.div`
  width: 100%;
  background-color: #fffbeb;

  display: flex;
  justify-content: center;
  align-items: flex-start;
`;

const Background = styled.div`
  width: 100%;
  max-width: 1144px;
  min-height: calc(100vh - 252px);

  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  padding-bottom: 80px;

  ${responsive.tablet(css`
    max-width: unset;
    padding-bottom: 50px;
    min-height: calc(100vh);
  `)}

  ${responsive.mobile(css`
    padding-bottom: 40px;
  `)}
`;

const Banner = styled.div`
  position: relative;
  width: 100%;
  max-width: 1144px;

  display: flex;
  flex-direction: column;
  align-items: center;

  ${responsive.tablet(css`
    max-width: unset;
  `)}
`;

const ImageContainer = styled.div`
  width: 100%;
  position: absolute;
`;

const BannerImage = styled.img`
  width: 100%;
  margin: 0;
  z-index: 1;
`;

const BannerImageDT = styled(BannerImage)`
  ${responsive.tablet(css`
    display: none;
  `)}
`;

const BannerImageTB = styled(BannerImage)`
  display: none;
  ${responsive.tablet(css`
    display: flex;
  `)}
  ${responsive.mobile(css`
    display: none;
  `)}
`;

const BannerImageMB = styled(BannerImage)`
  display: none;
  ${responsive.mobile(css`
    display: flex;
  `)}
`;

const BannerDescriptionContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  border-radius: 8px;
  background-color: white;
  max-width: 824px;

  z-index: 1;

  padding: 40px 24px 42px;

  box-shadow: 0px -4px 8px rgba(0, 0, 0, 0.1);

  ${responsive.tablet(css`
    max-width: 575px;

    padding: 30px 16px 32px;
  `)}

  ${responsive.mobile(css`
    max-width: unset;
    padding: 14px 16px 16px;
  `)}
`;

const BannerDescription = styled.span`
  font-family: "Noto Sans Thai", "Noto Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;

  color: #4b5768;

  ${responsive.tablet(css`
    font-size: 18px;
    line-height: 26px;
  `)}

  ${responsive.mobile(css`
    font-size: 14px;
    line-height: 21px;
  `)}
`;

const BannerDescriptionContainerS = styled.div`
  position: relative;
  margin-top: 159px;
  border-radius: 8px;
  background-color: white;
  max-width: 824px;

  z-index: 1;

  padding: 40px 24px 42px;

  ${responsive.tablet(css`
    max-width: 575px;
    margin-top: 19vw;

    padding: 30px 16px 32px;
  `)}

  ${responsive.mobile(css`
    width: calc(100% - 32px);
    margin-top: 22.9vw;
    bottom: unset;

    padding: 14px 16px 16px;
  `)}
`;

export default Description;
